import React from 'react';
import moment from 'moment';

import { noteShape } from 'constants/propTypes';

import { Container, Heading, Content } from './NoteDetail.styles';

const NoteDetail = ({ detail }) => (
  <Container data-cy="note-detail">
    <Heading>
      <strong>{moment(detail.createdAt).format('Do MMM YYYY [at] HH:mm')}</strong> <span>{detail.author}</span>
    </Heading>
    <Content>{detail.content}</Content>
  </Container>
);

NoteDetail.propTypes = {
  detail: noteShape.isRequired
};

export default NoteDetail;
